/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 包裹核对列表 的 **请求配置**
 *
 * @分类 #5413
 * @请求头 `POST /erp/SupplyPackage/getPage`
 */
const postGetPageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackage/getPage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 包裹核对列表 的 **请求函数**
 *
 * @分类 #5413
 * @请求头 `POST /erp/SupplyPackage/getPage`
 */
export const postGetPage = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetPageRequestConfig, requestData), ...args);
};
postGetPage.requestConfig = postGetPageRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 物流信息 的 **请求配置**
 *
 * @分类 4.54.0
 * @请求头 `POST /erp/SupplyPackage/getShippingDetail`
 */
const postGetShippingDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/SupplyPackage/getShippingDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetShippingDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 物流信息 的 **请求函数**
 *
 * @分类 4.54.0
 * @请求头 `POST /erp/SupplyPackage/getShippingDetail`
 */
export const postGetShippingDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetShippingDetailRequestConfig, requestData),
    ...args
  );
};
postGetShippingDetail.requestConfig = postGetShippingDetailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyPackage.js